module.exports = __webpack_public_path__ + "img/logo-apa-black.e980520f.svg";